import { render, staticRenderFns } from "./CreateGroupSurveyDetails.vue?vue&type=template&id=310dcac0&scoped=true"
import script from "./CreateGroupSurveyDetails.vue?vue&type=script&lang=js"
export * from "./CreateGroupSurveyDetails.vue?vue&type=script&lang=js"
import style0 from "./CreateGroupSurveyDetails.vue?vue&type=style&index=0&id=310dcac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310dcac0",
  null
  
)

export default component.exports